import { type PayloadAction, createSlice } from "@reduxjs/toolkit"
import { FindMatchMode, IFindMatchSliceState } from "."

const getFindMatchModeLocalStorage = () => {
  return window.localStorage.getItem("findMatchMode") as FindMatchMode
}

export const initialState: IFindMatchSliceState = {
  mode: getFindMatchModeLocalStorage() || "modal",
  isSearching: false
}

export const FindMatchSlice = createSlice({
  name: "findMatch",
  initialState,
  reducers: {
    setFindMatchMode: (
      state,
      { payload }: PayloadAction<IFindMatchSliceState["mode"]>
    ) => {
      state.mode = payload
      localStorage.setItem("findMatchMode", payload)
    },
    setFindMatchIsSearching: (state, { payload }: PayloadAction<boolean>) => {
      state.isSearching = payload
    }
  }
})

export const { setFindMatchMode, setFindMatchIsSearching } =
  FindMatchSlice.actions
